import React from "react";
import { FaFacebookF, FaTwitter, FaLinkedinIn } from 'react-icons/fa';
 
import Copyright from "./Copyright.component";
import { Link } from "react-router-dom";


// images
import logo from "../../assets/images/logo.png";
import playStoreImg from "../../assets//images/index/footer/img-01.jpg";
import appleStoreImg from "../../assets//images/index/footer/img-02.jpg";


export default function Footer1() {
  return (
    <>
      {/* <!-- FOOTER START --> */}
      <footer className="bds-mainfooter">
        <div className="container">
          <div className="row bds-footer gy-4">
            <div className="col-lg-6">
              <div className="bds-footeritem">
                <figure>
                  <Link to="#">
                    <img src={logo} alt="3bids logo" className="site-logo" />
                  </Link>
                </figure>
                <div className="bds-main-description">
                  <p>
                    3bids is a trusted marketplace for people and businesses to outsource their tasks, whether you are looking for work or you need someone to do a specific task we are here to help you hire. Skilled people can earn extra income through our website or mobile app.
                  </p>
                </div>  
                <ul className="bds-storeicons">
                  <li>
                      <a href="https://play.google.com/store/apps/details?id=com.bids.app">
                        <img src={playStoreImg} alt="image" width={"130px"} height={100}   />
                    </a>
                  </li>
                  <li>
                      <a href="https://apps.apple.com/us/app/3-bids/id1620499159">
                        <img src={appleStoreImg} alt="image" width={"130px"} height={100}   />
                    </a>
                  </li>
                </ul>              
              </div>
            </div>
            <div className="col-sm-6 col-lg-3">
              <div className="bds-footerlinks">
                <div className="bds-foootertittle">
                  <h5>Useful links</h5>
                </div>
                <ul className="bds-footerlink">
                  <li>
                      <Link to="/">Home</Link>
                  </li>
                  <li>
                      <Link to="/jobs">Jobs Listings</Link>
                  </li>
                  <li>
                      <Link to="/blogs">Blogs</Link>
                  </li>
                  <li>
                      <Link to="#">Terms and conditions</Link>
                  </li>
                  <li>
                      <Link to="#">Copyright policy</Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-sm-6 col-lg-3">
              <div className="bds-footerlinks">
                <div className="bds-foootertittle">
                  <h5>Social Links</h5>
                </div>
                <ul className="bds-footerlink">
                  <li>
                      <a href="https://www.facebook.com/3bids-103537545706107" target="_blank">                    
                        <FaFacebookF /> <span className="ms-3">/3bids</span>
                    </a>
                  </li>
                  <li>
                      <Link to="#">                   
                        <FaTwitter /> <span className="ms-3">/socialmediaurl</span>
                    </Link>
                  </li>
                  <li>
                      <Link to="#"><FaLinkedinIn /> <span className="ms-3">/socialmediaurl</span>
                    </Link>
                  </li>
                </ul>
                
              </div>
            </div>
          </div>
        </div>
      </footer>
      {/* <!-- FOOTER END --> */}
      <Copyright />
    </>
  );
}
